import React from "react";
import {
  AiOutlineInstagram,
  AiOutlineYoutube,
  AiOutlineMail,
  AiOutlineLinkedin,
  AiOutlineAmazon,
} from "react-icons/ai";
import { FaTiktok, FaPodcast } from "react-icons/fa";
import { HiOutlineGlobeAlt } from "react-icons/hi";
import { StaticCompnents } from "../../../../../Utils/StaticComponent";
import { PlatformCategory } from "./PlatformTypes";
import { IoLogoTiktok } from "react-icons/io5";
import { RiTiktokFill } from "react-icons/ri";

const PlatformConfigGenerator = ({
  instagramUsername,
  setInstagramUsername,
  youtubeUsername,
  setYoutubeUsername,
  twitterUsername,
  setTwitterUsername,
  tiktokUsername,
  setTiktokUsername,
  linkedinProfileUrl,
  setLinkedinProfileUrl,
  newsletterEmail,
  setNewsletterEmail,
  newsletterWebsiteLink,
  setNewsletterWebsiteLink,
  podcastShowName,
  setPodcastShowName,
  podcastShowUrl,
  setPodcastShowUrl,
  websiteLink,
  setWebsiteLink,
  linkinBioLink,
  setLinkinBioLink,
  amazonLink,
  setAmazonLink,
  shopmyLink,
  setShopmyLink,
  ltkLink,
  setLtkLink,
}: any): PlatformCategory[] => {
  const platformIcons: any = {
    ShopMy: StaticCompnents().ShopMyIcon,
    Amazon: StaticCompnents().AmazonIcon,
    LTK: StaticCompnents().LTKIcon,
  };
  const ShopMyIcon = platformIcons["ShopMy"];
  const LTKIcon = platformIcons["LTK"];

  const platformCategories: PlatformCategory[] = [
    {
      title: "Content Platforms",
      platforms: [
        {
          id: "instagram",
          name: "Instagram",
          icon: <AiOutlineInstagram className="platform-icon" />,
          inputValue: instagramUsername,
          setInputValue: setInstagramUsername,
        },
        {
          id: "youtube",
          name: "YouTube",
          icon: <AiOutlineYoutube className="platform-icon" />,
          inputValue: youtubeUsername,
          setInputValue: setYoutubeUsername,
        },
        {
          id: "twitter",
          name: "X",
          icon: <span className="platform-icon"><svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            className="bi bi-twitter-x"
            viewBox="0 0 16 16"
          >
            <path d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z" />
          </svg></span>,
          inputValue: twitterUsername,
          setInputValue: setTwitterUsername,
        },
        {
          id: "tiktok",
          name: "TikTok",
          icon: <RiTiktokFill className="platform-icon" />,
          inputValue: tiktokUsername,
          setInputValue: setTiktokUsername,
        },
        {
          id: "linkedin",
          name: "LinkedIn",
          icon: <AiOutlineLinkedin className="platform-icon" />,
          inputValue: linkedinProfileUrl,
          setInputValue: setLinkedinProfileUrl,
        },
        {
          id: "newsletter",
          name: "Newsletter",
          icon: <AiOutlineMail className="platform-icon" />,
          inputValue: newsletterEmail,
          setInputValue: setNewsletterEmail,
          websiteLink: {
            value: newsletterWebsiteLink,
            setValue: setNewsletterWebsiteLink,
            placeholder: "Enter newsletter subscription URL",
            label: "Subscription URL",
          },
        },
        {
          id: "podcast",
          name: "Podcast",
          icon: <FaPodcast className="platform-icon" />,
          inputValue: podcastShowName,
          setInputValue: setPodcastShowName,
          secondaryInput: {
            value: podcastShowUrl,
            setValue: setPodcastShowUrl,
            placeholder: "Enter Podcast Show URL",
            label: "Show URL",
          },
        },
      ],
    },
    /*
    {
      title: "Content Platforms",
      platforms: [
        {
          id: "website",
          name: "Website",
          icon: <HiOutlineGlobeAlt className="platform-icon" />,
          inputValue: websiteLink,
          setInputValue: setWebsiteLink,
        },
      ],
    },
    {
      title: "LinkinBio",
      platforms: [
        {
          id: "linkinbio",
          name: "LinkinBio",
          icon: <AiOutlineLink className="platform-icon" />,
          inputValue: linkinBioLink,
          setInputValue: setLinkinBioLink,
        },
      ],
    },
    */
    {
      title: "Affiliate Platforms",
      platforms: [
        {
          id: "amazon",
          name: "Amazon",
          icon: <AiOutlineAmazon className="platform-icon" />,
          inputValue: amazonLink,
          setInputValue: setAmazonLink,
        },
        {
          id: "shopmy",
          name: "ShopMy",
          icon: (
            <span style={{ display: "inline-flex", marginRight: "6px" }} className="platform-icon">
              <ShopMyIcon className="platform-icon" />
            </span>
          ),
          inputValue: shopmyLink,
          setInputValue: setShopmyLink,
        },
        {
          id: "ltk",
          name: "LTK",
          icon: <LTKIcon className="platform-icon" />,
          inputValue: ltkLink,
          setInputValue: setLtkLink,
        },
      ],
    },
  ];

  return platformCategories;
};

export default PlatformConfigGenerator; 